
import { Component } from '@angular/core';
import { ContextChange, WidgetStyle } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { Transport, TransportSelection } from '../../../../common/model/transport.model';

@Component({
  selector: 'app-transport-action-bar-widget',
  templateUrl: './transport-action-bar.component.html'
})
export class TransportActionBarWidgetComponent extends AbstractWidgetComponent {

  transport: Transport;

  selection: TransportSelection;

  constructor() {
    super();
  }

  onContextChange(contextChange: ContextChange) {

    if (contextChange.key === 'selected-transport') {
      console.log('transport selection is changing', contextChange.value);
      this.transport = contextChange.value;
    }

    if (contextChange.key === 'transport-selection') {
      console.log('received new trnasport selection', contextChange.value)
      this.selection  = contextChange.value;
    }

  }

  onSetElementAndContext() { }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
